/** 이 클라이언트를 가리키는 단말 식별자.
 *
 * 서버는 refresh 토큰을 (serviceId, memberNo, deviceId) 로 관리하고,
 * 갱신할 때 그 키로 지운 뒤 새로 넣습니다. 그래서 모두가 같은 값을 보내면
 * 서로 한 행을 공유해 한쪽이 갱신하는 순간 다른 쪽이 로그아웃됩니다.
 * 예전에는 웹 전체가 'web-device' 하나를 썼습니다.
 */

/** 앱 웹뷰면 네이티브가 쓰는 단말 ID 를 그대로 씁니다.
 *  안 그러면 같은 기기인데 행이 둘로 갈려 서로의 토큰을 죽입니다.
 *  (구버전 앱은 이 값을 주입하지 않으므로 없으면 아래 웹 ID 로 떨어집니다) */
const nativeDeviceId = (): string | null => {
    try {
        const id = (window as any).__APP__?.deviceId;
        return typeof id === 'string' && id ? id : null;
    } catch {
        return null;
    }
};

const STORAGE_KEY = 'webDeviceId';

/** 브라우저마다 한 번 만들어 두고 계속 쓰는 값 */
const webDeviceId = (): string => {
    try {
        let id = localStorage.getItem(STORAGE_KEY);
        if (!id) {
            id = 'web-' + (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`);
            localStorage.setItem(STORAGE_KEY, id);
        }
        return id;
    } catch {
        // 저장소를 못 쓰는 환경 — 예전 동작 그대로 둡니다
        return 'web-device';
    }
};

export const getDeviceId = (): string => nativeDeviceId() || webDeviceId();
